import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';

import { HotelResultData } from '@hiptraveler/data-access/api';
import { ItineraryState } from '@hiptraveler/data-access/itinerary';
import { SentimentAnalysis } from './sentiment-analysis.interface';

@Component({
  selector: 'sentiment-analysis',
  templateUrl: './sentiment-analysis.component.html',
  styleUrls: ['./sentiment-analysis.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SentimentAnalysisComponent implements OnInit, OnDestroy {

  @Select(ItineraryState.hotelInformation) hotelInformation$: Observable<HotelResultData | null>;
  
  @Input() hotel?: HotelResultData;

  showDescriptions: boolean = false;
  sentimentAnalysis: SentimentAnalysis | null = null;
  
  private destroy$ = new Subject<void>();
  
  constructor() { }

  ngOnInit(): void {
    // Subscribe to hotel information to get real sentiment analysis data
    this.hotelInformation$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((hotelInfo: HotelResultData | null) => {
      if (hotelInfo?.sentimentAnalysis && this.isValidSentimentAnalysis(hotelInfo.sentimentAnalysis)) {
        this.sentimentAnalysis = hotelInfo.sentimentAnalysis;
      } else if (this.hotel?.sentimentAnalysis && this.isValidSentimentAnalysis(this.hotel.sentimentAnalysis)) {
        this.sentimentAnalysis = this.hotel.sentimentAnalysis;
      } else {
        this.sentimentAnalysis = null;
      }
    });
  }

  private isValidSentimentAnalysis(data: any): data is SentimentAnalysis {
    return data && 
           Array.isArray(data.categories) && 
           data.categories.length > 0 &&
           data.categories.every((category: any) => 
             category && 
             typeof category.name === 'string' && 
             typeof category.rating === 'number' &&
             typeof category.description === 'string'
           );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleDescriptions(): void {
    this.showDescriptions = !this.showDescriptions;
  }

}
